<template>
  <!-- TODO: EChart的数据刷新 -->
  <!-- TODO: 非高频数据，本地缓存 -->
  <!-- 投票历史数据 -->
  <div class="section">
    <div class="title">
      <div>
        <img class="icon" src="../../assets/icons/chart-up-2.png">
        {{$t('superNode.votingHistoryData')}}
      </div>
    </div>
    <!-- 图表 -->
    <div class="chart">
      <v-chart v-if="!isLoading" :options="option" ref="chart"></v-chart>
    </div>
    <!-- 加载中 -->
    <dna-spin v-if="isLoading"></dna-spin>
  </div>
</template>

<script>
import "echarts/lib/chart/line";
import "echarts/lib/component/legend";
import "echarts/lib/component/tooltip";
import wsSubscribe from "@/req/wsSubscribe.js";
import req from "@/req/req.js";
import util from "@/util/util.js";
export default {
  data() {
    return {
      isLoading: true,
      periods: ["1", "2", "3", "4", "5", "6", "7"],
      usersData: [0, 0, 0, 0, 0, 0, 0],
      votesData: [0, 0, 0, 0, 0, 0, 0],
      // TODO: 样式细节处理（SplitLine的虚线部分）
      option: {
        backgroundColor: "#1C1D22",
        grid: {
          left: 32,
          right: 44
          //   width: "100%"
        },
        // legend: {
        //   top: 15,
        //   textStyle: {
        //     color: "#FFF",
        //     fontSize: 18
        //   },
        //   data: ["Users", "Votes"],
        //   selectedMode: false,
        //   icon: "circle"
        // },
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          //   boundaryGap: true,
          data: this.date,
          axisLabel: {
            color: "rgba(255, 255, 255, 0.5)",
            fontSize: 9,
            margin: 12
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#FFF"
            }
          },
          axisTick: {
            length: 0
          },
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "rgba(255, 255, 255, 0.5)",
            fontSize: 9,
            // padding: 30
            margin: -20
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#FFF"
            }
          },
          axisTick: {
            length: 0
          },
          splitLine: {
            show: true,
            padding: 30,
            lineStyle: {
              color: "#2B2D3A",
              type: "solid"
            }
          }
        },
        series: [
          {
            name: "Users",
            data: this.usersData,
            type: "line",
            // smooth: 0.5,
            symbol: "none",
            // areaStyle: {
            //   color: "rgba(164,68,255, 0.2)"
            // },
            itemStyle: {
              normal: {
                color: "#00B7FF",
                lineStyle: {
                  color: "#00B7FF"
                }
              }
            }
          },
          {
            type: "line",
            name: "Votes",
            // smooth: 0.5,
            symbol: "none",
            // areaStyle: {
            //   color: "rgba(0,183,255,0.2)"
            // },
            data: this.votesData,
            itemStyle: {
              normal: {
                color: "#FC7204",
                lineStyle: {
                  color: "#FC7204"
                }
              }
            }
          }
        ]
      }
    };
  },
  async mounted() {
    let that = this;
    try {
      await that.load();
      this.isLoading = false;
    } catch (err) {
      console.log(err);
      that.isLoading = false;
      that.$Message.error({
        background: true,
        duration: 5,
        content: that.$t("global.networkError")
      });
    }
    window.addEventListener("resize", () => {
      try {
        that.$refs.chart.resize();
      } catch (e) {}
    });
    // // TODO: 模拟获取数据
    // setTimeout(() => {
    //   that.usersData = [10000, 16000, 14000, 17000, 40000, 10000, 37000];
    //   that.votesData = [5000, 13000, 12500, 20000, 20000, 17000, 25000];
    //   // console.log()
    //   that.option.xAxis.data = that.periods;
    //   that.option.series[0].data = that.usersData;
    //   that.option.series[1].data = that.votesData;
    //   that.isLoading = false;
    // }, 2000);
  },
  methods: {
    async load() {
      let currentRound = await this.getCurrentRound();
      await this.getRecentRounds(currentRound);
    },
    async getCurrentRound() {
      let blockStatus = await req.fetchBlockStatus();
      return blockStatus && blockStatus.cur_round ? blockStatus.cur_round : 0;
    },
    async getRecentRounds(currentRound, maxRounds = 7) {
      let that = this;
      let usersData = [];
      let votesData = [];
      let periods = [];
      if (!that.address) {
        return;
      }
      while (currentRound > 0 && maxRounds > 0) {
        let result = await req.fetchVoteInfo(
          currentRound,
          1,
          1,
          that.address
        );
        //console.log(result);
        if (result && result.nodes && result.nodes.length) {
          periods.push(result.round);
          votesData.push(util.toToken(result.nodes[0].votes));
          usersData.push(result.nodes[0].vote_user_num);
        }
        currentRound--;
        maxRounds--;
      }
      periods.reverse();
      votesData.reverse();
      usersData.reverse();

      that.usersData = usersData;
      that.votesData = votesData;
      that.periods = periods;
      // console.log()
      that.option.xAxis.data = that.periods;
      that.option.series[0].data = that.usersData;
      that.option.series[1].data = that.votesData;
      that.isLoading = false;
    }
  },
  computed: {
    net() {
      return this.$store.state.net;
    },
    address() {
      return (
        this.$store.state.userInfo.name || this.$store.state.userInfo.address
      );
    }
  }
};
</script>

<style lang="less" scoped>
@import url("./SuperNodeVoteHistory.less");
</style>